/// <reference types="signalr" />
import * as angular from 'angular';
import { IKWFServerState } from '@common/rwfsignalrtypes';
import { NavSettingsService, INavCustomization } from '@common/services/settingsservice';
import { AppVersion } from '@common/interfaces';
import { CompatibilityService } from '@services/compatibilityservice';
import { RwfBackend, RwfBootstrap } from '@common/rwf';
import { RwfInvoiceData, RwfInvoiceDataService } from '@common/rwf/rwfinvoicedata';
import { InjectionResolve } from '@services/autoresolveservice';
import { RwfAppSettings } from '@common/rwf/rwf.appsettings';
import { IWebApiRoot } from './navdata';
import { RwfSignalRService } from '@common/rwfsignalr';
import { RwfApplicationService } from '@common/rwf/rwf.application';
import { KWFNotificationService } from "./KWFNotificationService";
import { RenderAsLinkProps, IInfNotification } from '@common/navkendo';
import { FwfDataService } from '@common/rwf/fwfdata.service';
export { RwfInvoiceData, RwfInvoiceDataService };

/** Root KWF Application Service */
export class KWFApplicationService extends RwfApplicationService {
    static $inject = ["CompatibilityService", "InfomaAppVersion", "KWFNotificationService"];
    constructor(
        public readonly $c: CompatibilityService,
        appVersion: AppVersion,
        private notification: IInfNotification) {
        super($c, appVersion);

    }

    /** Notify Version State change to ui */
    protected notifyVersion(clientVersion: AppVersion, serverVersion: AppVersion) {

        let appState = <IKWFServerState><any>this.ApplicationState,
            notification = this.notification,
            reloaduttonHtml = ` <span  class="k-button idms_ml10" inf-operation="AppActions.ForceReloadPage"><span class="k-icon k-i-refresh" style="position:relative;top:-1px"></span> Seite neu laden</span>`;

        const IsInfomaOnline = appState.IsInfomaOnline

        if (serverVersion && serverVersion.Version && clientVersion && clientVersion.Version) {
            // Skip version check if both client and server are in develop mode
            var skipDevelopCheck = clientVersion.Version === "develop" && serverVersion.Version === "develop";
            var versionMismatch = !skipDevelopCheck && (serverVersion.Version !== clientVersion.Version || serverVersion.PatchLevel !== clientVersion.PatchLevel);
            var navVersionMismatch = serverVersion.NavVersion && clientVersion.Version && (clientVersion.Version != "develop") && this.versionCheck(clientVersion, serverVersion, IsInfomaOnline);
        }

        if (versionMismatch)
            var warning = "Die Anwendung wurde aktualisiert, bitte laden Sie die Seite neu.";
        else if (navVersionMismatch)
            warning = IsInfomaOnline?
                "Die newsystem-Version (" + serverVersion.NavVersion + ") entspricht nicht der Anwendungs-Version (" + clientVersion.Version + "). Der Workflow wird automatisch aktualisiert, bitte laden Sie die Seite in Kürze erneut.":
                "Die newsystem-Version (" + serverVersion.NavVersion + ") entspricht nicht der Anwendungs-Version (" + clientVersion.Version + "), kontaktieren Sie Ihren Administrator!"
        else
            warning = (appState.ShutDownWarning && appState.ShutDownWarning.Message);

        if (notification) {
            if (warning)
                notification.AddNotification({
                    message: warning + (versionMismatch ? reloaduttonHtml : ""),
                    hint: warning,
                    messageType: "error",
                    identifier: "KWF.ClientWarning"
                });
            else
                notification.RemoveNotifications("KWF.ClientWarning");
        }
    }

    private versionCheck(clientVersion: AppVersion, serverVersion: AppVersion, IsInfomaOnline:Boolean): Boolean
    {
        const cVersion = clientVersion.Version.split(".",3);
        const sVersion = serverVersion.NavVersion.split(".",3);
         
        if (cVersion[0] != sVersion[0] || cVersion[1] != sVersion[1])
            return true
        else if (IsInfomaOnline && +sVersion[2] > +cVersion[2]){
            if(clientVersion.MaxBuild !== "0" && +sVersion[2] > +clientVersion.MaxBuild)
                return true
        }
       
        return false;
    }
}

const RwfBootstrapProvider: ng.IServiceProvider = {
    $get: ["CompatibilityService", ($c: CompatibilityService) => new RwfBootstrap($c)]
};

/* RWF SignalR Implementation for angualrjs */
const RwfSignalRProvider: ng.IServiceProvider = {
    $get: ["CompatibilityService", "WebApiRoot",
        ($c: CompatibilityService, webApiRoot: IWebApiRoot) => new RwfSignalRService($c, webApiRoot)]
};

// Decoupled for structured testing ...
angular.module("KWF.Services", ["infoma.nav"])
    .service("RwfBackend", ["CompatibilityService", ($c: CompatibilityService) => new RwfBackend($c)])
    .provider("RwfBootstrap", RwfBootstrapProvider)
    .provider("RwfSignalRService", RwfSignalRProvider)
    .service("KWFApplication", KWFApplicationService)
    .provider("RwfRoot", { $get: ["$injector", ($injector: ng.auto.IInjectorService) => (token) => InjectionResolve($injector, token)] })
    .provider("Rwf", { $get: ["$injector", ($injector: ng.auto.IInjectorService) => (token) => InjectionResolve($injector, token)] })
    .service("RwfAppSettings", ["CompatibilityService", "NavSettings", "NavCustomization", "RwfBootstrap",
        ($c: CompatibilityService, NavSettings: NavSettingsService,
            NavCustomization: INavCustomization,
            RwfBootsrap: RwfBootstrap) => new RwfAppSettings($c, NavSettings, NavCustomization, RwfBootsrap)])
    .service("RwfInvoiceData", ["CompatibilityService", "RwfBootstrap",
        ($c: CompatibilityService, rwf: RwfBootstrap) => new RwfInvoiceDataService($c, rwf)])
    .service('FwfDataService', ["CompatibilityService",
    ($c: CompatibilityService) => new FwfDataService($c)])
    .service("KWFNotificationService", KWFNotificationService);

/** In RWF : CustPropX should render as link */
RenderAsLinkProps.push(...["CustProp1", "CustProp2", "CustProp3", "CustProp4", "CustProp5"]);
